import { render } from "./UserWallet.vue?vue&type=template&id=356d05ae"
import script from "./UserWallet.vue?vue&type=script&lang=js"
export * from "./UserWallet.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__